import { Actions, createNamespace } from "../../flux/Actions";
import { Entity } from "../../models/Entity";
import { EntityType } from "../../models/EntityType";

const ns = createNamespace('EditEntity');
export const names = {
    SET_EDIT_ENTITY: ns('SET_EDIT_ENTITY'),
    SET_ENTITY_PROTOTYPE: ns('SET_ENTITY_PROTOTYPE'),
    REJECT_DRAFT: ns('REJECT_DRAFT'),
};

export class EditCreateEntityActions extends Actions
{
    setEntityToEdit = (entity: Entity, entityType: EntityType) => this.dispatch(names.SET_EDIT_ENTITY, entity, entityType);
    setEntityPrototype = (entity: Entity, entityType: EntityType) => this.dispatch(names.SET_ENTITY_PROTOTYPE, entity, entityType);
    rejectDraft = (entityType: EntityType) => this.dispatch(names.REJECT_DRAFT, null, entityType);
}


// WEBPACK FOOTER //
// ./src/app/actions/EditCreateEntityActions.ts